exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#accessList tfoot tr td {\r\n  padding: 10px 0 0 0;\n}\n#accessList tfoot tr td > :first-child {\r\n  margin-left: 0;\n}\r\n", ""]);

// exports
